import React, { useEffect, useState } from "react";
import "./App.css";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Loader from "./components/Loader";
import Home from "./pages/Home";
// import Sidebar from "components/Sidebar";
import Chat from "./pages/Chat";
import { CurrentUserProvider } from "./context/currentUserContext";
import { ChatsProvider } from "./context/chatsContext";
import { useCurrentWindowHeight } from "hooks/useCurrentWindowHeight";
import configureStore from "stores/configureStore";
import { Provider } from "react-redux";
import axios from "axios";
import { viewFor } from "utils/constants";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "../src/assets/css/theme";

const store = configureStore();

const userPrefersDark =
  window.matchMedia &&
  window.matchMedia("(prefers-color-scheme: dark)").matches;

const ChatWrapper = ({ match, ...props }) => {
  var urlSearchParams = new URLSearchParams(window.location.search);
  var params = Object.fromEntries(urlSearchParams.entries());

  const [chatId, setChatId] = useState(match.params.id);
  const [adminId, setAdminId] = useState(match.params.adminId);
  const [error, setError] = useState("");
  const [laoder, showLoder] = useState(false);
  var businessType =
    document.location.hash.toLocaleLowerCase() === "#toothsi"
      ? "Toothsi"
      : document.location.hash.toLocaleLowerCase() === "#skinnsi"
      ? "Skinnsi"
      : "";

  useEffect(() => {
    if (params.chatId) {
      setChatId(params.chatId);
    }
  }, [chatId, params]);

  if (laoder) {
    return <div className="widget-loader">Loading...</div>;
  }

  if (!error.length) {
    return (
      <Provider store={store}>
        <ThemeProvider theme={theme}>
          <CurrentUserProvider
            chatId={chatId}
            adminId={adminId}
            customerId={params.customerId}
          >
            <Chat chatId={chatId} />
          </CurrentUserProvider>
        </ThemeProvider>
      </Provider>
    );
  } else {
    return <div className="chat-bot-load-error">{error}</div>;
  }
};

function App() {
  // const [appLoaded, setAppLoaded] = useState(false);
  // const [startLoadProgress, setStartLoadProgress] = useState(false);
  const appContentHeight = useCurrentWindowHeight();

  // useEffect(() => {
  // if (userPrefersDark) document.body.classList.add("dark-theme");
  //   stopLoad();
  // }, []);

  // const stopLoad = () => {
  //   setStartLoadProgress(true);
  //   setTimeout(() =>
  //   setAppLoaded(true),
  //   3000);
  // };

  // if (!appLoaded) return <Loader done={startLoadProgress} />;

  return (
    <div className={`app ${viewFor === "user" ? "user-view" : viewFor}`}>
      <p className="app__mobile-message"> Only available on desktop 😊. </p>
      {/* <Router basename="/admin/chat_app_frontend"> */}
      <Router>
        <div className="app-content">
          {/* <Sidebar /> */}
          <Switch>
            <Route
              path="/admin/chat_app_frontend/:id/:adminId?"
              component={ChatWrapper}
            />
            <Route path="/transcript/chat/:id" component={ChatWrapper} />
            <Route path="/user/chat/:id" component={ChatWrapper} />
            <Route path="/" component={ChatWrapper} />
          </Switch>
        </div>
      </Router>
    </div>
  );
}

export default App;
